import type { SortItem, SortEvent, SortAlgorithm } from '@/core/types';
import { EventRecorderImpl } from '@/core/EventRecorderImpl';

export class ShellSort implements SortAlgorithm {
  readonly name = 'Shell Sort';
  readonly category = 'comparison' as const;
  readonly stable = false;
  readonly inPlace = true;
  readonly adaptive = true;
  readonly best = 'O(n log n) - depends on gap sequence';
  readonly average = 'O(n^1.3) - Knuth gap sequence';
  readonly worst = 'O(n^2) - bad gap sequence';
  readonly space = 'O(1) - in-place';

  run(input: SortItem[]): SortEvent[] {
    const recorder = new EventRecorderImpl();
    const arr = input.map(item => ({ ...item }));
    const n = arr.length;

    // Knuth gap sequence: 1, 4, 13, 40, 121, ...
    let gap = 1;
    while (gap < n / 3) gap = gap * 3 + 1;

    while (gap >= 1) {
      recorder.record({ type: 'gap', gap });
      for (let i = gap; i < n; i++) {
        const key = { ...arr[i] };
        let j = i;
        while (j >= gap) {
          recorder.record({ type: 'compare', indices: [j - gap, j] });
          if (arr[j - gap].value > key.value) {
            recorder.record({ type: 'overwrite', index: j, value: arr[j - gap] });
            arr[j] = arr[j - gap];
            arr[j].currentIndex = j;
            j -= gap;
          } else break;
        }
        recorder.record({ type: 'overwrite', index: j, value: key });
        arr[j] = key;
        arr[j].currentIndex = j;
      }
      gap = Math.floor(gap / 3);
    }

    recorder.record({ type: 'done', indices: arr.map((_, i) => i) });
    return recorder.events;
  }
}
